module.exports = __webpack_public_path__ + "static/media/header-book.37f554ed.PNG";